import SodWidget from './SodWidget';

export default SodWidget;
